import { SHELL_ID } from "@aviv-unified-frontend/internal";
import { useTranslation } from "@aviv-unified-frontend/runtime/i18n";
export const useTranslate = () => useTranslation(SHELL_ID).t;
